import React, { useRef, useLayoutEffect, useState } from 'react';
import { motion, useMotionValue, useAnimationFrame, useTransform } from 'framer-motion';
import './TrackVisualizer.css';

function useElementWidth(ref) {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    function updateWidth() {
      if (ref.current) {
        setWidth(ref.current.offsetWidth);
      }
    }
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [ref]);

  return width;
}

function MarqueeBand({ children, velocity = 50, direction = 1 }) {
  const baseX = useMotionValue(0);
  const copyRef = useRef(null);
  const copyWidth = useElementWidth(copyRef);

  function wrap(min, max, v) {
    const range = max - min;
    const mod = (((v - min) % range) + range) % range;
    return mod + min;
  }

  const x = useTransform(baseX, v => {
    if (copyWidth === 0) return '0px';
    return `${wrap(-copyWidth, 0, v)}px`;
  });

  useAnimationFrame((t, delta) => {
    const moveBy = direction * velocity * (delta / 1000);
    baseX.set(baseX.get() + moveBy);
  });

  return (
    <div className="track-visualizer__wrapper">
      <motion.div className="track-visualizer__band" style={{ x }}>
        <span ref={copyRef}>{children}</span>
        <span>{children}</span>
        <span>{children}</span>
        <span>{children}</span>
      </motion.div>
    </div>
  );
}

export function TrackVisualizer({ track, isPlaying }) {
  if (!isPlaying || !track) return null;

  const trackText = `${track}\u00A0\u00A0\u00A0`;

  return (
    <div className="track-visualizer">
      <MarqueeBand velocity={80} direction={-1}>
        {trackText}
      </MarqueeBand>
      <MarqueeBand velocity={80} direction={1}>
        {trackText}
      </MarqueeBand>
    </div>
  );
}

export default TrackVisualizer;
